import { ROUTE_SETTINGS } from '@/router/constants'
const router = document.router

const goToSettings = () => router.push({ name: ROUTE_SETTINGS }).catch(() => {})
const SET_CONNECTED = 'SET_CONNECTED'

const actions = {
  startListeners ({ state, commit }) {
    const commitStatus = () => {
      const connected = Boolean(navigator.onLine)
      const isChanged = state.connected !== connected
      commit(SET_CONNECTED, { connected, isChanged })
    }

    window.addEventListener('online', commitStatus)
    window.addEventListener('offline', commitStatus)
    commitStatus()
  }
}

const mutations = {
  [SET_CONNECTED]: (state, { connected }) => {
    Object.assign(state, { connected })
  }
}

const middlewares = {
  'connectionModule/SET_CONNECTED' (context, { payload: { connected, isChanged } }) {
    const customer = context.getters['settingsModule/customer']
    if (!customer) return goToSettings()
    if (isChanged && connected) return context.dispatch('authModule/checkSession', null, { root: true })
  }
}

const getters = {
  connected: (state) => state.connected
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  middlewares,
  state: { connected: false }
}
